import { render, staticRenderFns } from "./franchises.vue?vue&type=template&id=0bbdea39"
import script from "./franchises.vue?vue&type=script&lang=js"
export * from "./franchises.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports